import React from "react";

/* Loader — page / section / inline spinner. Token-driven, theme-correct,
   self-contained (SVG SMIL rotation; no CSS keyframes dependency).
   role="status" + aria-live so assistive tech announces the busy state.
   Replaces the legacy Loader / PageLoader / LoadingCircle (REG-378 part 3, FR-002). */

const SIZES = { inline: 18, section: 32, page: 44 };

function Spinner({ px }) {
  const stroke = Math.max(2, Math.round(px / 12));
  const r = (px - stroke) / 2;
  const c = px / 2;
  return (
    <svg width={px} height={px} viewBox={`0 0 ${px} ${px}`} fill="none" aria-hidden="true" style={{ display: "block" }}>
      <circle cx={c} cy={c} r={r} stroke="var(--border)" strokeWidth={stroke} />
      <circle
        cx={c}
        cy={c}
        r={r}
        stroke="var(--green-success)"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeDasharray={`${Math.PI * r * 0.3} ${Math.PI * r * 2}`}
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          from={`0 ${c} ${c}`}
          to={`360 ${c} ${c}`}
          dur="0.8s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  );
}

export function Loader({ variant = "section", size, label = "Loading…", style, ...rest }) {
  const px = size || SIZES[variant] || SIZES.section;
  const wrap =
    variant === "page"
      ? { minHeight: 240, display: "flex", alignItems: "center", justifyContent: "center" }
      : variant === "section"
        ? { padding: 24, display: "flex", alignItems: "center", justifyContent: "center" }
        : { display: "inline-flex", alignItems: "center" };
  return (
    <div role="status" aria-live="polite" style={{ ...wrap, ...style }} {...rest}>
      <Spinner px={px} />
      <span
        style={{
          position: "absolute",
          width: 1,
          height: 1,
          padding: 0,
          margin: -1,
          overflow: "hidden",
          clip: "rect(0 0 0 0)",
          whiteSpace: "nowrap",
          border: 0,
        }}
      >
        {label}
      </span>
    </div>
  );
}

export default Loader;
